var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSparkles(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.65625 0.5C5.65625 4.4585 3.517 8 0.5 8C3.517 8 5.65625 11.5417 5.65625 15.5C5.65625 11.5417 7.7955 8 10.8125 8C7.7955 8 5.65625 4.4585 5.65625 0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 8C11.75 9.9795 10.6808 11.75 9.17175 11.75C10.6808 11.75 11.75 13.521 11.75 15.5C11.75 13.521 12.8193 11.75 14.3283 11.75C12.8193 11.75 11.75 9.9795 11.75 8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.922 0.5C12.922 2.47925 11.8527 4.25 10.3438 4.25C11.8525 4.25 12.922 6.021 12.922 8C12.922 6.021 13.9912 4.25 15.5002 4.25C13.9912 4.25 12.922 2.47925 12.922 0.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkles);
export default __webpack_public_path__ + "static/media/sparkles.b0da3df86ed78716dbdca5d1714ae632.svg";
export { ForwardRef as ReactComponent };